import { ProfileInfoFieldType } from '../../../Widget'
import { getUserInfoStatuses } from '../../User.api'
import {
  getUserProfilePreferredCommunicationOptionsData,
  getUserProfileSalutationOptionsData,
} from '../UserProfileWidget.api'
import {
  USER_PROFILE_INFO_FULL_NAME_FIELD_NAME,
  USER_PROFILE_INFO_GDPR_INFO_FIELD_NAME,
  USER_PROFILE_INFO_MIDDLE_NAME_FIELD_NAME,
  USER_PROFILE_INFO_NAME_INFO_FIELD_NAME,
  USER_PROFILE_INFO_PREFERRED_COMMUNICATION_FIELD_NAME,
  USER_PROFILE_INFO_SALUTATION_FIELD_NAME,
  USER_PROFILE_INFO_STATUS_FIELD_NAME,
  USER_PROFILE_INFO_TITLE_FIELD_NAME,
} from '../UserProfileWidget.constants'

export const PERSONAL_INFO_FIELDS = [
  {
    getOptionsData: getUserProfileSalutationOptionsData,
    labelKey: 'Widget.InfoSalutationLabelKey',
    name: USER_PROFILE_INFO_SALUTATION_FIELD_NAME,
    optionLabelKey: 'salutation',
    placeholderKey: 'Widget.InfoSalutationPlaceholderKey',
    type: ProfileInfoFieldType.SELECT,
  },
  {
    labelKey: 'Widget.InfoPersonalTitleLabelKey',
    maxLength: 100,
    name: USER_PROFILE_INFO_TITLE_FIELD_NAME,
    placeholderKey: 'Widget.InfoPersonalTitlePlaceholderKey',
    type: ProfileInfoFieldType.TEXT,
  },
  {
    labelKey: 'Widget.InfoMiddleNameLabelKey',
    maxLength: 100,
    name: USER_PROFILE_INFO_MIDDLE_NAME_FIELD_NAME,
    placeholderKey: 'Widget.InfoMiddleNamePlaceholderKey',
    type: ProfileInfoFieldType.TEXT,
  },
  {
    labelKey: 'Widget.InfoFullNameLabelKey',
    maxLength: 256,
    name: USER_PROFILE_INFO_FULL_NAME_FIELD_NAME,
    placeholderKey: 'Widget.InfoFullNamePlaceholderKey',
    type: ProfileInfoFieldType.TEXT,
  },
  {
    labelKey: 'Widget.InfoPostNominalLettersLabelKey',
    maxLength: 100,
    name: USER_PROFILE_INFO_NAME_INFO_FIELD_NAME,
    placeholderKey: 'Widget.InfoPostNominalLettersPlaceholderKey',
    type: ProfileInfoFieldType.TEXT,
  },
  {
    getOptionsData: getUserInfoStatuses,
    labelKey: 'Widget.InfoPersonalStatusLabelKey',
    name: USER_PROFILE_INFO_STATUS_FIELD_NAME,
    placeholderKey: 'Widget.InfoPersonalStatusPlaceholderKey',
    type: ProfileInfoFieldType.SELECT,
  },
  {
    labelKey: 'Widget.InfoGdprInfoLabelKey',
    maxLength: 1024,
    name: USER_PROFILE_INFO_GDPR_INFO_FIELD_NAME,
    placeholderKey: 'Widget.InfoGdprInfoPlaceholderKey',
    type: ProfileInfoFieldType.TEXT,
  },
  {
    getOptionsData: getUserProfilePreferredCommunicationOptionsData,
    labelKey: 'Widget.InfoPreferredCommunicationLabelKey',
    name: USER_PROFILE_INFO_PREFERRED_COMMUNICATION_FIELD_NAME,
    placeholderKey: 'Widget.InfoPreferredCommunicationPlaceholderKey',
    type: ProfileInfoFieldType.SELECT,
  },
]
